import { render } from "./EconomicOverview.vue?vue&type=template&id=33dd93c6&scoped=true&ts=true"
import script from "./EconomicOverview.vue?vue&type=script&lang=ts"
export * from "./EconomicOverview.vue?vue&type=script&lang=ts"

import "./EconomicOverview.vue?vue&type=style&index=0&id=33dd93c6&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dd93c6"]])

export default __exports__